import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-md w-full mx-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-3xl xxs:text-4xl font-black mb-8" }, "Login", -1)
const _hoisted_3 = { class: "bg-white py-8 px-4 xs:px-10 shadow sm:rounded-lg" }

import { provide, ref } from 'vue'
import { useRouter } from 'vue-router'
import { gsap } from 'gsap'
// Other modules
import { SignInStep } from '@/types'
// Components
import SignIn from '@/components/login/SignIn.vue'
import PasswordReset from '@/components/login/PasswordReset.vue'
import ForcedNewPassword from '@/components/login/ForcedNewPassword.vue'
import { RouteName } from '@/router/RouteName'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const step = ref<SignInStep>('signIn')

provide('setStep', (signInStep: SignInStep) => {
  step.value = signInStep

  if (step.value === 'complete') {
    router.replace({ name: RouteName.dashboard })
  }
})

/* Transition animations
 ************************/
function beforeEnter(el: Element) {
  gsap.set(el, { autoAlpha: 0 })
}

function enter(el: Element, done: gsap.Callback) {
  gsap.to(el, { duration: 1, autoAlpha: 1, ease: 'power1.out', onComplete: done })
}

function leave(el: Element, done: gsap.Callback) {
  gsap.to(el, { duration: 1, autoAlpha: 1, ease: 'power1.in', onComplete: done })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_Transition, {
        mode: "out-in",
        onBeforeEnter: beforeEnter,
        onEnter: enter,
        onLeave: leave,
        css: false
      }, {
        default: _withCtx(() => [
          (step.value === 'signIn')
            ? (_openBlock(), _createBlock(SignIn, { key: 0 }))
            : (step.value === 'passwordReset')
              ? (_openBlock(), _createBlock(PasswordReset, { key: 1 }))
              : (step.value === 'forcedNewPassword')
                ? (_openBlock(), _createBlock(ForcedNewPassword, { key: 2 }))
                : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})